"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    CouponAlreadyUsed: 4,
    CouponMinPriceNotReached: 5
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/CouponResponseExtension.js
// module id = 564
// module chunks = 0 2